import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";
import { ALLIN_DEADLINE } from "../../data/funnelContent";

const PATHS = new Set(["/", "/sluzby", "/pricing", "/cennik"]);
const KEY = "trp_allin_banner_closed";

// Top strip promoting the "Všetko v jednom 2026" bundle on home, services and pricing.
export const AllInBanner = () => {
  const { pathname } = useLocation();
  const [closed, setClosed] = useState(() => sessionStorage.getItem(KEY) === "1");
  const days = Math.ceil((ALLIN_DEADLINE - new Date()) / 86400000);
  if (closed || days <= 0 || !PATHS.has(pathname)) return null;
  const close = () => { sessionStorage.setItem(KEY, "1"); setClosed(true); };
  return (
    <div className="relative z-[60] bg-gradient-to-r from-[#6d28d9] via-[#7c3aed] to-[#a855f7] text-white" data-testid="allin-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 pr-12 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center text-sm">
        <span className="inline-flex items-center gap-1.5 font-black"><Sparkles className="w-4 h-4" /> Všetko v jednom 2026</span>
        <span className="text-white/90">8 nástrojov za <strong>€79/mes</strong>, cena zamknutá navždy · alebo €590 do konca roka</span>
        <span className="hidden sm:inline text-white/80 font-mono text-xs" data-testid="allin-banner-days">zostáva {days} dní</span>
        <Link to="/vsetko-v-jednom-2026" className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white text-[#6d28d9] font-black text-xs uppercase tracking-wider hover:bg-white/90 transition-colors" data-testid="allin-banner-cta">
          Pozrieť ponuku <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      <button onClick={close} aria-label="Zavrieť" className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-white/80 hover:text-white" data-testid="allin-banner-close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
